export const LibraryModalMode = {
	MY_LIBRARY: 'My Library',
	MY_SHARES: 'Shared with my operators',
	BEEYOU: 'Beeyou Library',
	SHARED_BY_CHANNEL: 'Shared by channel',
};
